/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect, useCallback, Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { AppState } from '../../types'
import { fetchCountries } from '../../redux/actions'
import useCountries from '../../hooks/useCountries'
import MainTable from '../../components/MainTable'
import Header from '../../components/Header'
import Pagination from '../../components/Pagination'

import './style.scss'

export default function Home() {
  const dispatch = useDispatch()
  const loadingCountries = useSelector(
    (state: AppState) => state.countries.isLoading
  )
  const [search, setSearch] = useState('')
  const [sortCountry, setSortCountry] = useState('')
  const [reverseSort, setReverseSort] = useState(false)
  const [err, data] = useCountries(search, sortCountry, reverseSort)
  const [currentPage, setCurrentPage] = useState(1)
  const [countriesPerPage] = useState(30)

  //get current books
  const indexLastCountry = currentPage * countriesPerPage
  const indexFirstCountry = indexLastCountry - countriesPerPage
  const currentCountries = data?.slice(indexFirstCountry, indexLastCountry)

  const [isNameReversing, setIsNameReversing] = useState(false)
  const [isPopReversing, setIsPopReversing] = useState(false)
  const [isRegionReversing, setIsRegionReversing] = useState(false)

  const paginate = (pageNumber: any) => setCurrentPage(pageNumber)

  useEffect(() => {
    dispatch(fetchCountries())
  }, [dispatch])

  const handleSubmit = (e: any) => {
    e.preventDefault()
  }

  const handleChange = (e: any) => {
    setSearch(e.target.value)
  }

  const sortCountries = (e: any) => {
    setSortCountry(e.target.value)
    changeArrowValue(e.target.value)
    setReverseSort(!reverseSort)
  }

  //will update the UI of the arrows taking the changeValue from the custom hook
  const changeArrowValue = useCallback(
    (changeValue: any) => {
      switch (changeValue) {
      case 'name':
        setIsNameReversing(!isNameReversing)
        break
      case 'population':
        setIsPopReversing(!isPopReversing)
        break
      case 'region':
        setIsRegionReversing(!isRegionReversing)
        break
      default:
      }
    },
    [isNameReversing, isPopReversing, isRegionReversing]
  )

  return (
    <>
      <Fragment>
        <Header
          countries={data}
          search={search}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
        />
        {!loadingCountries && !err ? (
          <div className="loading-container">
            <h1>Loading Countries...</h1>
            <div className="lds-circle">
              <div></div>
            </div>
          </div>
        ) : (
          <div>
            <div className="countries">
              <MainTable
                countries={search === '' ? currentCountries : data}
                sortCountries={sortCountries}
                isNameReversing={isNameReversing}
                isPopReversing={isPopReversing}
                isRegionReversing={isRegionReversing}
              />
            </div>
            {search === '' && (
              <Pagination
                itemsPerPage={countriesPerPage}
                totalItems={data?.length}
                currentPage={currentPage}
                paginate={paginate}
              />
            )}
          </div>
        )}
      </Fragment>
    </>
  )
}
